import * as React from "react"
import GeLogoWithLightText from "src/global/ui/Image/assets/image/geLogoColorFull.svg?react"
import GeLogoWithDarkText from "src/global/ui/Image/assets/image/geLogoWithDarkText.svg?react"
import GeLogoSmall from "src/global/ui/Image/assets/image/geLogoColorSmall.svg?react"
import Maintenance from "src/global/ui/Image/assets/image/maintenance.svg?react"
import GEText from "src/global/ui/Image/assets/image/Text.svg?react"
import Approve from "src/global/ui/Image/assets/image/approve.svg?react"
import Close from "src/global/ui/Image/assets/image/close.svg?react"
import GithubLogo from "src/global/ui/Image/assets/image/githubLogo.svg?react"
import GoogleLogo from "src/global/ui/Image/assets/image/googleLogo.svg?react"
import GoogleLogoColored from "src/global/ui/Image/assets/image/googleLogoTransparentBackground.svg?react"
import AdditionalInfo from "src/global/ui/Image/assets/image/additional-info.svg?react"
import Link from "src/global/ui/Image/assets/image/link.svg?react"
import graphPerson from "src/global/ui/Image/assets/image/graphPerson.svg?react"
import pipelinePerson from "src/global/ui/Image/assets/image/pipelinePerson.svg?react"
import Code from "src/global/ui/Image/assets/image/code.svg?react"
import Slack from "src/global/ui/Image/assets/image/slack.svg?react"
import Batch from "src/global/ui/Image/assets/image/batch.svg?react"
import SuccessIcon from "src/global/ui/Image/assets/image/success.svg?react"
import FailureIcon from "src/global/ui/Image/assets/image/failure.svg?react"
import Numeric from "src/global/ui/Image/assets/image/numeric.svg?react"
import Sparkles from "src/global/ui/Image/assets/image/sparkles.svg?react"
import alloyDBFullLogo from "src/global/ui/Image/assets/image/alloyDBFullLogo.svg?react"
import amazonS3FullLogo from "src/global/ui/Image/assets/image/amazonS3FullLogo.svg?react"
import azureBlobStorageFullLogo from "src/global/ui/Image/assets/image/azureBlobStorageFullLogo.svg?react"
import auroraPostgreSQLFullLogo from "src/global/ui/Image/assets/image/auroraPostgreSQLFullLogo.svg?react"
import citusDBFullLogo from "src/global/ui/Image/assets/image/citusDBFullLogo.svg?react"
import databricksFullLogo from "src/global/ui/Image/assets/image/databricksFullLogo.svg?react"
import googleBigQueryFullLogo from "src/global/ui/Image/assets/image/googleBigQueryFullLogo.svg?react"
import googleCloudStorageFullLogo from "src/global/ui/Image/assets/image/googleCloudStorageFullLogo.svg?react"
import neonFullLogo from "src/global/ui/Image/assets/image/neonFullLogo.svg?react"
import pandasFullLogo from "src/global/ui/Image/assets/image/pandasFullLogo.svg?react"
import postgreSQLFullLogo from "src/global/ui/Image/assets/image/postgreSQLFullLogo.svg?react"
import redShiftFullLogo from "src/global/ui/Image/assets/image/redShiftFullLogo.svg?react"
import snowflakeFullLogo from "src/global/ui/Image/assets/image/snowflakeFullLogo.svg?react"
import sparkFullLogo from "src/global/ui/Image/assets/image/sparkFullLogo.svg?react"

interface Image {
  src: React.FunctionComponent
  ariaLabel: string
  alt: string
}

export const images = {
  geLogoWithLightText: {
    src: GeLogoWithLightText,
    ariaLabel: "Great Expectations Logo",
    alt: "Great Expectations Logo",
  },
  geLogoWithDarkText: {
    src: GeLogoWithDarkText,
    ariaLabel: "Great Expectations Logo",
    alt: "Great Expectations Logo",
  },
  geLogoSmall: {
    src: GeLogoSmall,
    ariaLabel: "Great Expectations Logo",
    alt: "Great Expectations Logo",
  },
  geText: {
    src: GEText,
    ariaLabel: "Great Expectations",
    alt: "Great Expectations",
  },
  graphPerson: {
    src: graphPerson,
    ariaLabel: "Person holding a graph",
    alt: "Person holding a graph",
  },
  pipelinePerson: {
    src: pipelinePerson,
    ariaLabel: "Person and data pipeline",
    alt: "Person and data pipeline",
  },
  additionalInfo: {
    src: AdditionalInfo,
    ariaLabel: "Additional info",
    alt: "Additional info",
  },
  approve: {
    src: Approve,
    ariaLabel: "Approve",
    alt: "Approve",
  },
  close: {
    src: Close,
    ariaLabel: "Close",
    alt: "Close",
  },
  githubLogo: {
    src: GithubLogo,
    ariaLabel: "GitHub Logo",
    alt: "GitHub Logo",
  },
  googleLogo: {
    src: GoogleLogo,
    ariaLabel: "Google Logo",
    alt: "Google Logo",
  },
  googleLogoColored: {
    src: GoogleLogoColored,
    ariaLabel: "Google Logo",
    alt: "Google Logo",
  },
  maintenance: {
    src: Maintenance,
    ariaLabel: "Maintenance tools",
    alt: "Maintenance tools",
  },
  link: {
    src: Link,
    ariaLabel: "Link",
    alt: "Link",
  },
  code: {
    src: Code,
    ariaLabel: "Code",
    alt: "Code",
  },
  slack: {
    src: Slack,
    ariaLabel: "Slack",
    alt: "Slack",
  },
  batch: {
    src: Batch,
    ariaLabel: "Batch",
    alt: "Batch",
  },
  success: {
    src: SuccessIcon,
    ariaLabel: "Success",
    alt: "Success",
  },
  failure: {
    src: FailureIcon,
    ariaLabel: "Failure",
    alt: "Failure",
  },
  numeric: {
    src: Numeric,
    ariaLabel: "Hashtag icon",
    alt: "Numeric",
  },
  sparkles: {
    src: Sparkles,
    ariaLabel: "Sparkles",
    alt: "Sparkles",
  },
  alloyDBLogo: {
    src: alloyDBFullLogo,
    ariaLabel: "AlloyDB Logo",
    alt: "AlloyDB Logo",
  },
  amazonS3Logo: {
    src: amazonS3FullLogo,
    ariaLabel: "Amazon S3 Logo",
    alt: "Amazon S3 Logo",
  },
  azureBlobStorageLogo: {
    src: azureBlobStorageFullLogo,
    ariaLabel: "Azure Blob Storage Logo",
    alt: "Azure Blob Storage Logo",
  },
  auroraPostgreSQLLogo: {
    src: auroraPostgreSQLFullLogo,
    ariaLabel: "Aurora PostgreSQL Logo",
    alt: "Aurora PostgreSQL Logo",
  },
  citusDBLogo: {
    src: citusDBFullLogo,
    ariaLabel: "CitusDB Logo",
    alt: "CitusDB Logo",
  },
  databricksLogo: {
    src: databricksFullLogo,
    ariaLabel: "Databricks Logo",
    alt: "Databricks Logo",
  },
  googleBigQueryLogo: {
    src: googleBigQueryFullLogo,
    ariaLabel: "Google BigQuery Logo",
    alt: "Google BigQuery Logo",
  },
  googleCloudStorageLogo: {
    src: googleCloudStorageFullLogo,
    ariaLabel: "Google Cloud Storage Logo",
    alt: "Google Cloud Storage Logo",
  },
  neonLogo: {
    src: neonFullLogo,
    ariaLabel: "Neon Logo",
    alt: "Neon Logo",
  },
  pandasLogo: {
    src: pandasFullLogo,
    ariaLabel: "Pandas Logo",
    alt: "Pandas Logo",
  },
  postgreSQLLogo: {
    src: postgreSQLFullLogo,
    ariaLabel: "PostgreSQL Logo",
    alt: "PostgreSQL Logo",
  },
  redShiftLogo: {
    src: redShiftFullLogo,
    ariaLabel: "RedShift Logo",
    alt: "RedShift Logo",
  },
  snowflakeLogo: {
    src: snowflakeFullLogo,
    ariaLabel: "Snowflake Logo",
    alt: "Snowflake Logo",
  },
  sparkLogo: {
    src: sparkFullLogo,
    ariaLabel: "Spark Logo",
    alt: "Spark Logo",
  },
} as const satisfies Record<string, Image>
